export enum DayTradeSessionState {
  IDLE = 'IDLE',
  WATCHING_BUY = 'WATCHING_BUY',
  HOLDING = 'HOLDING',
  WATCHING_SELL = 'WATCHING_SELL',
  // display-only override when the session cannot run as configured
  ERROR = 'ERROR',
}
